import templates from '../../api/templates'
import groupMessages from '../../api/groupMessages'
import { Message } from 'element-ui'

const state = {
  general_templates: [],
  vip_templates: [],
  template_id: null,
  content: '',
  title: ''
};

const actions = {
  // 获取模板列表
  async 'groupMessage/getTemplates' ({ commit }, payload) {
    const response = await templates.getTemplates(payload);
    if (response.status === 200) {
      const { data } = response;
      commit('groupMessage/UPDATE_TEMPLATES', {
        templates: data.templates
      });
    }
  },
  // 批量发送短信
  async sendMessages ({ dispatch, commit }, payload) {
    const { router } = payload;
    const response = await groupMessages.sendMessages(payload.data);
    if (response.status === 202) {
      Message.success('提交成功');
      if (payload.task) return router.push('/report/inHttp/httpDetail');
      else router.push('/report/inHttp/httpDetail');
    }
  },
  async asyncMessages ({ dispatch, commit }, payload) {
    const { router } = payload;
    const response = await groupMessages.asyncMessages(payload.data);
    if (response.status === 202) {
      Message.success('提交成功');
      if (payload.task) return router.push('/report/inHttp/httpDetail');
      else router.push('/report/inHttp/httpDetail');
    }
  },
  // 发送超级短信
  async sendMms ({ dispatch, commit }, payload) {
    const { router } = payload;
    const response = await groupMessages.sendMms(payload.data);
    if (response.status === 200) {
      Message.success('提交成功');
      if (payload.task) return router.push('/report/inHttp/httpDetail');
      else router.push('/report/inHttp/httpDetail');
    }
  }
};

const mutations = {
  'groupMessage/UPDATE_TEMPLATES': (state, payload) => {
    if (payload.report_type === 'general') {
      state.general_templates = payload.templates.filter(item => {
        return item.status === 'success';
      });
    } else {
      state.vip_templates = payload.templates.filter(item => {
        return item.status === 'success';
      });
    }
  },
  'groupMessage/UPDATE_TEMPLATE_ID': (state, payload) => {
    state.template_id = payload.value;
  },
  'groupMessage/UPDATE_CONTENT': (state, payload) => {
    state.content = payload.value;
  },
  'groupMessage/UPDATE_TITLE': (state, payload) => {
    state.title = payload.value;
  }
};

export default {
  state,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/groupMessage.js